import api from "@/lib/api";
import { toast } from "sonner";
import { MessageCircle, ExternalLink } from "lucide-react";
import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function WhatsAppDispatch({ jobId }) {
  const [links, setLinks] = useState(null);
  const [open, setOpen] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get(`/jobs/${jobId}/whatsapp-links`);
      setLinks(data);
      setOpen(true);
    } catch {
      toast.error("Impossibile preparare i messaggi");
    }
  };

  return (
    <>
      <Button
        type="button"
        variant="outline"
        onClick={load}
        className="h-10 border-emerald-200 bg-emerald-50 hover:bg-emerald-100 text-emerald-800"
        data-testid="whatsapp-dispatch-button"
      >
        <MessageCircle className="w-4 h-4 mr-2" /> Avvisa su WhatsApp
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-extrabold flex items-center gap-2">
              <MessageCircle className="w-5 h-5 text-emerald-600" /> Avvisa i dipendenti su WhatsApp
            </DialogTitle>
          </DialogHeader>
          <p className="text-sm text-slate-500 -mt-2">
            Tocca "Invia" accanto a ogni dipendente: WhatsApp si aprirà con il messaggio già pronto, dovrai solo premere invio.
          </p>
          <div className="divide-y divide-slate-100 bg-white rounded-xl border border-slate-200">
            {(links || []).length === 0 && (
              <div className="p-6 text-center text-slate-400 text-sm">Nessun dipendente assegnato.</div>
            )}
            {(links || []).map((l) => (
              <div key={l.employee_id} className="p-3 flex items-center gap-3" data-testid={`wa-row-${l.employee_id}`}>
                <div className="w-10 h-10 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center font-bold text-sm">
                  {l.employee_name?.split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-slate-900 truncate">{l.employee_name}</div>
                  <div className="text-xs font-mono text-slate-500 truncate">{l.phone || "Numero mancante"}</div>
                </div>
                {l.whatsapp_url ? (
                  <a href={l.whatsapp_url} target="_blank" rel="noreferrer"
                     className="inline-flex items-center gap-1 bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-lg text-xs font-semibold"
                     data-testid={`wa-send-${l.employee_id}`}>
                    <ExternalLink className="w-3.5 h-3.5" /> Invia
                  </a>
                ) : (
                  <span className="text-xs text-rose-600 italic">Numero non valido</span>
                )}
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
